import { OtsState } from "../store/ots-store";
import { useSelector } from "react-redux";

export function useOtsSelector<T>(
  selector: (state: OtsState) => T,
  equalityFn?: (left: T, right: T) => boolean
) {
  return useSelector(selector, equalityFn);
}
